/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class VerticalNavService {
private _animateOnCollapsed: Subject<boolean> = new Subject<boolean>();
/**
 * @return {?}
 */
get animateOnCollapsed(): Observable<boolean> {
        return this._animateOnCollapsed.asObservable();
    }
private _collapsedChanged: Subject<boolean> = new Subject<boolean>();
/**
 * @return {?}
 */
get collapsedChanged(): Observable<boolean> {
        return this._collapsedChanged.asObservable();
    }
private _collapsed: boolean = false;
/**
 * @return {?}
 */
get collapsed(): boolean {
        return this._collapsed;
    }
/**
 * @param {?} value
 * @return {?}
 */
set collapsed(value: boolean) {
        value = !!value;
        if (this.collapsible && (this._collapsed !== value)) {
            this.updateCollapseBehavior(value);
        }
    }
private _collapsible: boolean = false;
/**
 * @return {?}
 */
get collapsible(): boolean {
        return this._collapsible;
    }
/**
 * @param {?} value
 * @return {?}
 */
set collapsible(value: boolean) {
        value = !!value;
        if (this._collapsible !== value) {
            if (!value && this.collapsed) {
                this.updateCollapseBehavior(false);
            }
            this._collapsible = value;
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
private updateCollapseBehavior(value: boolean): void {
        this._animateOnCollapsed.next(value);
        this._collapsed = value;
        this._collapsedChanged.next(value);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VerticalNavService_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavService.ctorParameters;
/** @type {?} */
VerticalNavService.prototype._animateOnCollapsed;
/** @type {?} */
VerticalNavService.prototype._collapsedChanged;
/** @type {?} */
VerticalNavService.prototype._collapsed;
/** @type {?} */
VerticalNavService.prototype._collapsible;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
